// extracted by mini-css-extract-plugin
module.exports = {"css-transition":"Base_css-transition__1SFeD","anchor":"Base_anchor__3suVf"};